<template>
  <TemplateTwoColPage
    :breadcrumbs="breadcrumbs"
    class="group-of-accreditation-item"
    :class="{'is-open': currentBlock.component}"
    :current-block.sync="currentBlock"
    :data-qa="dataQa"
    :list-items="listItems"
    :loading="!item"
    @update:mini="$emit('update:mini', $event)">
    <template #header-actions>
      <ItemTopActions
        :options="{
          id: item ? item.id : null,
          number: item ? item.id : null,
          title: item ? item.title : '',
          showParticipantsLink: true,
          participantsLink: participantsLink,
          shareLabel: 'Посилання на групу акредитацій',
          routeLinkOrg: 'groupOfAccreditationsItem'
        }"/>
    </template>
    <template #left-content>
      <template v-if="loading.item">
        <v-skeleton-loader
          class="mt-10 pr-8"
          type="heading"
          width="100%"/>
        <v-skeleton-loader
          class="mt-3 pr-8"
          type="sentences"
          width="100%"/>
        <v-skeleton-loader
          class="mt-4 main__green mt-5"
          type="table-thead, table-tbody"
          width="100%"/>
      </template>
      <template v-else-if="item">
        <TemplateItemTitle
          class="px-2"
          :data-qa="dataQa + '-title'"
          :item="item"
          :loading="loading.item || titleEdit.loading"
          :options="{descriptionShow: false}">
          <div
            v-if="titleEdit.state"
            slot="title"
            class="flex gap-2 align-center"
            style="width: 100%;">
            <sButton
              :data-qa="`${dataQa}-title_btn-confirm`"
              icon="accept"
              small
              type="text"
              @click="confirmEdit"/>
            <sInput
              ref="valueInput"
              v-model="titleEdit.value"
              autofocus
              class="group-of-accreditation-item__title-input"
              :data-qa="`${dataQa}-title_input`"
              :max-length="254"
              :show-word-limit="true"
              @keydown_enter="confirmEdit"/>
          </div>
          <div
            v-else
            slot="title-actions">
            <sButton
              :data-qa="`${dataQa}-title_btn-edit`"
              icon="edit"
              small
              type="text"
              @click.stop="startEdit"/>
          </div>
          <sButton
            v-if="item.status === 'DRAFT' && !titleEdit.state"
            :disabled="titleEdit.state"
            :loading="loading.publish"
            @click="publishGroupOfAccreditation">
            {{ $t('Tenders.Publish') }}
          </sButton>
        </TemplateItemTitle>
        <GroupOfAccreditationItemBody
          class="px-2 pt-4"
          :data-qa="dataQa + '-item-body'"
          :item.sync="item"
          :loading="loading.item"/>
      </template>
      <template v-else>
        <sAlert
          class="mt-5"
          color="error"
          :data-qa="dataQa + '-error'"
          text>
          {{ $t('Common.ErrorTitle') }}
        </sAlert>
      </template>
    </template>
    <template #menu>
      <div
        v-if="currentBlock.component"
        class="group-of-accreditation-item__title">
        <div/>
        <span
          class="group-of-accreditation-item__title-label"
          data-qa="history-dialog-name">{{ currentBlock.name }}</span>
      </div>
      <div
        class="my-auto">
        <GroupOfAccreditationMenu
          :data-qa="dataQa + '-menu'"
          :disabled="titleEdit.state"
          :item="item ? item : {}"
          :loading="loading.item || !item"
          @deactivate="getItem"
          @publish="getItem"/>
      </div>
    </template>
    <template #rightContent="{ open }">
      <div
        v-if="currentBlock && currentBlock.component"
        class="group-of-accreditation-item__component"
        :class="{'is-open': open}"
        :data-qa="currentBlock.component">
        <component
          :is="currentBlock && currentBlock.component"
          v-bind="componentOptions"/>
      </div>
    </template>
  </TemplateTwoColPage>
</template>
<script>
import ItemTopActions from 'components/common/ItemTopActions.vue'
import TemplateItemTitle from 'components/templates/TemplateItemTitle.vue'
import TemplateTwoColPage from 'components/templates/TemplateTwoColPage.vue'
import GroupOfAccreditationMenu from 'components/group of accreditations/GroupOfAccreditationMenu.vue'
import GroupOfAccreditationItemBody from 'components/group of accreditations/GroupOfAccreditationItemBody.vue'
const GroupOfAccreditationInfo = () => import('components/group of accreditations/GroupOfAccreditationInfo.vue')

import displaySize from 'mixins/display-size'

import GroupOfAccreditationsApi from '@/api/groupOfAccreditationsApi'
const api = new GroupOfAccreditationsApi()

const pathCommercialParticipantAccreditation  = {
  uk: 'akredytatsiia-uchasnyka',
  ru: 'ru/akkreditatsiya-uchastnika',
  en: 'en/participant-accreditation',
}

export default {
  name: 'groupOfAccreditationItem',
  mixins: [ displaySize ],
  data() {
    return {
      loading: {
        item: true,
        publish: false,
        requests: false,
      },
      panelWidth: 480,

      titleEdit: {
        value: '',
        loading: false,
        state: false,
      },

      dataQa: 'group-of-accreditation-item',
      item: null,
      currentBlock: {},
      listItems: [
        {
          tabIcon: 'info',
          name: this.$t('groupOfAccreditation.aboutGroup'),
          component: 'GroupOfAccreditationInfo',
          badge: {},
          index: -1
        },
      ]
    }
  },
  methods: {
    confirmEdit() {
      const newValue = this.$refs.valueInput?.value ?? this.item.title
      if (newValue !== this.item.title) {
        this.titleEdit.loading = true
        api.updateAccreditationGroupTitle(this.itemId, newValue)
          .then((result) => {
            if (result) {
              this.item.title = newValue
            } else {
              this.$log_error('Error updating title')
              this.$notice.warning(
                {
                  title: this.$t('Common.ErrorTitle'),
                  message: this.$t('groupOfAccreditation.updateTitleError'),
                  showClose: true,
                  progress: true,
                  duration: 20
                }
              )
            }
          })
          .catch(res => this.$log_error(res))
          .finally(() => {
            this.titleEdit.loading = false
          })
      }
      
      this.titleEdit.value = ''
      this.titleEdit.state = false
    },
    startEdit() {
      this.titleEdit.value = this.item.title
      this.titleEdit.state = true
      this.$nextTick(() => {
        if (this.$refs.valueInput) {
          this.$refs.valueInput.focus()
        }
      })
    },
    async publishGroupOfAccreditation() {
      this.loading.publish = true
      await api.publishAccreditationGroup(this.itemId)
        .then((result) => {
          if (result) {
            this.getItem()
          }
        })
        .catch(res => this.$log_error(res))
        .finally(() => {
          this.loading.publish = false
        })
    },
    
    getHistoryStats(historyItems) {
      return historyItems.map(item => {
        const counts = {}

        for (const entry of item.history || []) {
          counts[entry.status] = (counts[entry.status] || 0) + 1
        }
        const historyStats = Object.entries(counts).map(([status, count]) => ({
          status,
          count,
          __typename: 'SupplierRequestStatisticGraph',
        }))

        return {
          ...item,
          historyStats,
        }
      })
    },
    modifyRequests(requests) {
      if (!requests?.length) {
        return
      }

      let result = requests ?? []
      result = this.getHistoryStats(result)
      return result
    },
    getItem() {
      this.loading.item = true
      api.getAccreditationGroupById(this.itemId)
        .then((response) => {
          if (!response) {
            this.$router.push({name: 'page-error', params: { status_code: 404, descript: 'GroupOfAccreditationItem not found'}})
          }
          response.id = this.itemId

          this.item = this.checkAndFixProblem(response)
          this.getRequests()
        })
        .catch(res => this.$log_error(res))
        .finally(() => {
          this.loading.item = false
        })
    },
    checkAndFixProblem(inputModel) {
      return {
        ...inputModel,
        categories: inputModel.categories.map(categoriItem => categoriItem || {})
      }
    },
    getRequests() {
      this.loading.requests = true

      api.getAccreditationRequestsWithHistory(this.itemId)
        .then((responseRequests) => {
          this.$set(this.item, 'requests', this.modifyRequests(responseRequests))
        })
        .catch(res => this.$log_error(res))
        .finally(() => {
          this.loading.requests = false
        })
    },
  },
  computed: {
    participantsLink() {
      return `${window.config?.SmarttenderUrl}${pathCommercialParticipantAccreditation[this.$i18n.locale]}/${this.itemId}/`
    },
    componentOptions() {
      switch (this.currentBlock?.component) {
      case 'GroupOfAccreditationInfo':
        return {
          ref: 'info',
          item: this.item || {},
          loading: this.loading.item,
          dataQa: this.dataQa + '-info',
        }
      default:
        return {}
      }
    },
    itemId() {
      return this.$route.params?.id
    },
    breadcrumbs() {
      return [
        {
          text: this.$t('Menu.GroupOfAccreditations'),
          to: { name: 'groupOfAccreditationsList' , params: {org: this.$route.params.org}}
        },
        {
          index: 1,
          maxLength: 20,
          text: this.item?.title || ('#' + this.itemId),
          loading: this.loading.item
        },
      ]
    },
  },
  created() {
    if (this.itemId) {
      this.getItem()
    }
  },
  components: {
    ItemTopActions,
    TemplateItemTitle,
    TemplateTwoColPage,
    GroupOfAccreditationMenu,
    GroupOfAccreditationInfo,
    GroupOfAccreditationItemBody,
  },
  props: {
  },
}
</script>

<style lang="scss">
$class: '.group-of-accreditation-item';

#{$class} {
  &__title-label,
  &__title-input>* {
    font-size: 24px;
    font-weight: 600;
    line-height: 32px;
  }
}
#{$class}.is-open {
  &__component {
    max-height: calc(100vh - var(--right-block-compact));
  }
}
</style>